import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import LockIcon from '@wix/da-ds/pkg/Icons/24x24/Lock';
import UnlockIcon from '@wix/da-ds/pkg/Icons/24x24/Unlock';
import { ChangeCommissionStatusPayload } from '../../../redux/commissions/actionCreators';
import { CommissionStatusCodes, CommissionStatusType } from '../../../types/commissions';
import CommissionConfirmation from '../../../CommissionEditPopup/CommissionConfirmation';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarEditButton from '../../_partials/items/ActionBarEditButton';

export interface Props {
  deviation: PapiDeviation;
  onClick: (payload: ChangeCommissionStatusPayload) => void;
}

export const CommissionStatusButton: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  onClick,
}) => {
  const { t } = useTranslation();
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);

  if (
    !deviation.commission ||
    deviation.commission.status === CommissionStatusCodes.STATUS_DELETED
  ) {
    return null;
  }

  const isActive = deviation.commission.status === CommissionStatusCodes.STATUS_ACTIVE;

  return (
    <>
      <ActionBarItemWrapper
        tooltip={isActive ? t('actionbar.closeCommission') : t('actionbar.openCommission')}
      >
        <ActionBarEditButton onClick={() => setShowConfirmationPopup(true)}>
          <ActionBarIcon icon={isActive ? UnlockIcon : LockIcon} />
        </ActionBarEditButton>
      </ActionBarItemWrapper>
      {showConfirmationPopup && (
        <CommissionConfirmation
          isOpen
          confirmationType={isActive ? 'disable' : 'enable'}
          onCancel={() => setShowConfirmationPopup(false)}
          onConfirm={() => {
            setShowConfirmationPopup(false);
            onClick({
              deviation,
              status: isActive ? CommissionStatusType.DISABLED : CommissionStatusType.ACTIVE,
            });
          }}
        />
      )}
    </>
  );
};
CommissionStatusButton.displayName = 'CommissionStatusButton';

export default CommissionStatusButton;
